'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { KuikBanks } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function Banner() {
  const t = useTranslations('Banks.Contact');

  return (
    <motion.section
      aria-label="Contact CTA Banner"
      className="w-full py-8 px-6 sm:px-10 lg:px-16 bg-white"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
    >
      <div className="max-w-8xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl bg-[#010D43] bg-gradient-to-r from-[#031561] via-[#041B75] to-[#010D43] p-8 sm:p-12 lg:p-14 text-white shadow-xl flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
           <div className="max-w-6xl space-y-4 relative z-10">
            <span className="text-[10px] sm:text-xs font-bold tracking-widest text-blue-400 uppercase block">
              {t('subtitle')}
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
              {t('title')}
            </h2>
            <p className="text-xs sm:text-sm lg:text-base text-white font-normal leading-relaxed pt-1">
              {t('description')}
            </p>
          </div>
          <div className="relative z-10 shrink-0 self-end md:self-center">
            <div className="relative w-32 h-24 sm:w-40 sm:h-28 flex items-center justify-center">
              <KuikBanks />
            </div>
          </div>

        </div>
      </div>
    </motion.section>
  );
}